export const TABLES = [
  {
    key: 'payoffs',
    displayValue: 'Payoffs',
  },
  {
    key: 'capitalProtection',
    displayValue: 'Capital Protection',
  },
  {
    key: 'ukspaCodes',
    displayValue: 'UKSPA Product Codes',
  },
  {
    key: 'underlyings',
    displayValue: 'Underlyings',
  },
  {
    key: 'issuers',
    displayValue: 'Issuer Reference Data',
  },
  {
    key: 'creditRatingDescriptions',
    displayValue: 'Credit Ratings',
  },
  {
    key: 'creditRatingOutlooks',
    displayValue: 'Credit Outlooks',
  },
  {
    key: 'defaultRiskDescriptions',
    displayValue: 'Default Risk Probabilities',
  },
  {
    key: 'tradingCalendars',
    displayValue: 'Trading Calendars',
  },
  {
    key: 'settlementCalendars',
    displayValue: 'Settlement Calendars',
  },
  {
    key: 'targetMarkets',
    displayValue: 'Target Markets',
  },
  {
    key: 'referenceEntity',
    displayValue: 'Reference Entity',
  },
  {
    key: 'referenceObligation',
    displayValue: 'Reference Obligation',
  },
  {
    key: 'agents',
    displayValue: 'Agents',
  },
  {
    key: 'issuersEntity',
    displayValue: 'Issuers',
  },
  {
    key: 'legalProgrammes',
    displayValue: 'Legal Programmes',
  },
  {
    key: 'listingVenues',
    displayValue: 'Listing Venues',
  },
  {
    key: 'physicalSettlementMatrix',
    displayValue: 'Physical Settlement Matrix',
  },
  {
    key: 'underlyingAssets',
    displayValue: 'Underlying Assets',
  },
  {
    key: 'exchanges',
    displayValue: 'Exchanges',
  },
  {
    key: 'dataIngestionConfig',
    displayValue: 'Data Ingestion',
    permittedForRoles: ['V2_ADMINISTRATOR'],
  },
  {
    key: 'dataExportFormats',
    displayValue: 'Data Export Formats',
    permittedForRoles: ['V2_ADMINISTRATOR'],
  },
  {
    key: 'desks',
    displayValue: 'Desks',
  },
  {
    key: 'contacts',
    displayValue: 'Contact Profile',
  },
  {
    key: 'hurdlesAndSpreads',
    displayValue: 'Hurdles and Spreads',
    permittedForRoles: ['V2_PRODUCT_GOVERNANCE_SUPERVISOR'],
  },
];
